// extracted by mini-css-extract-plugin
module.exports = {"img":"CampaignTask_img__3MFmc","hidden":"CampaignTask_hidden__33VLw"};